import {
  DeviceId,
  RepairTypeId,
} from '@service-initiation/shared-clients-tech-care-services';
import { type Repair } from '@service-initiation/tech-care-data-access-tech-care-services';

import { type DeviceType } from '../types';

export const isAlternativeEligibility = (
  selectedRepairs: Repair[],
  deviceType?: DeviceType
): boolean => {
  return (
    deviceType?.id === DeviceId.CellPhone &&
    !!selectedRepairs?.find(
      (sR) => sR.repairType.id === RepairTypeId.CrackedScreen
    )
  );
};
